module.exports = __webpack_public_path__ + "static/media/eng_d_2374.bc7b02a0.mp4";